<template>
  <div class="distribution-posters">
    <div class="slider-banner banner">
      <swiper class="swiper-wrapper" :options="swiperPosters" ref="mySwiper">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in info"
          :key="index"
        >
          <img
            class="slide-image"
            :src="item.wap_poster"
            @click="showwin(item)"
          />
        </swiperSlide>
      </swiper>
    </div>
    <!--<div class="keep bg-color-red" @click="saveImg">保存海报</div>-->
    <div class="preserve acea-row row-center-wrapper" v-if="!isapicloud">
      <div class="line"></div>
      <div class="tip">长按保存图片</div>
      <div class="line"></div>
    </div>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      description="提示"
      close-on-click-action
      @select="onSelect"
    />
  </div>
</template>
<style>
.preserve {
  color: #fff;
  text-align: center;
  margin-top: 0.2rem;
}
.preserve .line {
  width: 1rem;
  height: 0.01rem;
  background-color: #fff;
}
.preserve .tip {
  margin: 0 0.3rem;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getSpreadImg } from "../../../api/user";
import Vue from "vue";
import { ActionSheet } from "vant";
Vue.use(ActionSheet);
export default {
  name: "Poster",
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data: function() {
    return {
      show: false,
      actions: [{ name: "下载图片", index: 0 }],
      swiperPosters: {
        speed: 1000,
        effect: "coverflow",
        slidesPerView: "auto",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0, // 旋转的角度
          stretch: -20, // 拉伸   图片间左右的间距和密集度
          depth: 100, // 深度   切换图片间上下的间距和密集度
          modifier: 3, // 修正值 该值越大前面的效果越明显
          slideShadows: false // 页面阴影效果
        },
        observer: true,
        observeParents: true
      },
      isapicloud: false,
      info: [],
      imgsrc: "",
      activeIndex: 0
    };
  },
  mounted: function() {
    this.getIndex();
    this.gethuan();
    let that = this;
    this.swiper.on("slideChange", function() {
      that.activeIndex = that.swiper.activeIndex;
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    onSelect(item) {
      let that = this;
      var filename = "lucky_" + new Date().getTime() + ".jpg";
      if (item.index == 0) {
        var resultList = window.api.hasPermission({
          list: ["photos"]
        });
        var granted = resultList[0].granted;
        if (!granted) {
          let has = confirm("应用需要获取存储权限才能下载图片");
          if (has) {
            window.api.requestPermission({
              list: ["photos"]
            }),
              function(res) {
                alert(JSON.stringify(res));
              };
          }
          return;
        }
        window.api.download(
          {
            url: this.imgsrc,
            savePath: "fs://" + filename
          },
          function(ret, err) {
            if (ret.state == 1) {
              window.api.saveMediaToAlbum(
                {
                  path: "fs://" + filename
                },
                function(ret, error) {
                  if (ret && ret.status) {
                    that.$dialog.toast({ mes: "保存成功" });
                  } else {
                    console.log(error);
                    that.$dialog.toast({ mes: "保存失败" });
                  }
                }
              );
            } else {
              console.log(err);
              that.$dialog.toast({ mes: "保存失败" });
            }
          }
        );
      }
    },
    showwin(item) {
      let ua = navigator.userAgent;
      if (ua.indexOf("APICloud") > -1) {
        this.show = true;
        this.imgsrc = item.wap_poster;
      }
    },
    gethuan() {
      let ua = navigator.userAgent;
      if (ua.indexOf("APICloud") > -1) {
        this.isapicloud = true;
      } else {
        this.isapicloud = false;
      }
    },
    getIndex: function() {
      let that = this;
      getSpreadImg().then(
        res => {
          that.info = res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    }
    // downloadIamge: function(imgsrc, name) {
    //   let image = new Image();
    //   image.setAttribute("crossOrigin", "anonymous");
    //   image.onload = function() {
    //     let canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     let context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    //     let a = document.createElement("a"); // 生成一个a元素
    //     let event = new MouseEvent("click"); // 创建一个单击事件
    //     a.download = name || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = imgsrc;
    // },
    // saveImg: function() {
    //   console.log(this.info[this.activeIndex].wap_poster);
    //   this.downloadIamge(
    //     this.info[this.activeIndex].wap_poster,
    //     "poster" + this.activeIndex
    //   );
    // }
  }
};
</script>
